import { getSV } from '../utils/https';
import { getCookie } from '../utils/helper';

export const checkMyPermission = async () => {
  try {
    const auth = getCookie('token');
    if (!auth?.id) return null;
    const res = await getSV(`/listuserid?id=${auth.id}`);
    return Array.isArray(res) ? res[0] : res;
  } catch (error) {
    console.warn('Lỗi check quyền:', error);
    return null;
  }
};
